<template>
    <div :class="'img-' + size" class="custom-icon">
		<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M65 128c28.667-39.345 43-66.962 43-82.85C108 21.32 88.748 2 65 2S22 21.32 22 45.15C22 61.039 36.333 88.656 65 128z" class="path" stroke="#0C2340"/><ellipse class="highlight" stroke="#00BBDC" cx="65" cy="48.603" rx="17.2" ry="17.26"/></g></svg>
    </div>
</template>

<script>
    export default {
        props: {
            size: {
                type: String,
                default: '4x'
            }
        }
    }
</script>